import { IMultipleIdsParams } from '../../ts/ServerApi/types/actionParams';
import { IResult } from '../../ts/ServerApi/types/IResponse';
import { Request } from '../../ts/ServerApi/requests/Request';

export class DeleteSchedulesRequest extends Request<IMultipleIdsParams, IResult> {
  constructor(ids: string[]) {
    super('deleteSchedules', { ids: ids });
  }
}
